import { buildUrlWithQueryParams } from '../../utils/common/functions';
import { handleApi, handleOdinApi } from '../common';

const API_ENDPOINTS = {
	FETCH_HOLDINGS: '/api/equity/api/eqm/wave/holdings/v2',
	FETCH_HOLDINGS_V1: '/api/equity/api/eqm/wave/holdings',
	FETCH_POSITIONS: '/api/equity/api/eqm/wave/positions/v2',
	getInvestmentHistoryData:
		'/api/equity/api/eqm/wave/get/holdings/transactions/v2',
	bulkOrder: '/transactional/v1/orders/bulkOrders',
	convertPosition: '/transactional/v1/portfolio/positions',
	getPnlStatement: '/api/equity/api/eqm/refinitive/backoffice/pnl/fetch',

	// EDIS
	getEdiSummary: 'api/equity/api/eqm/wave/edis/summary',
	edisRedirect: '/api/equity/api/eqm/wave/edis/redirect',
	edisDpDetails: '/api/equity/api/eqm/wave/edis/dpdetails',
	generateNewTpin: '/api/equity/api/eqm/wave/edis/generate_tpin',
};

export const fetch_holdings = async (payload = {}, Api) => {
	const response = await Api.post(API_ENDPOINTS.FETCH_HOLDINGS, payload);
	const result = handleApi(response);
	return result;
};

export const fetch_positions = async (payload = {}, Api) => {
	const response = await Api.post(API_ENDPOINTS.FETCH_POSITIONS, payload);
	const result = handleApi(response);
	return result;
};

export const fetch_transaction_history = async (
	payload = {},
	Api,
	token = '',
) => {
	const response = await Api.post(
		API_ENDPOINTS.getInvestmentHistoryData,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const place_bulk_order = async (payload = {}, Api, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.bulkOrder,
		payload,
		{},
		token,
	);
	const result = handleOdinApi(response);
	return result;
};

export const convert_position = async (payload = {}, Api) => {
	const response = await Api.put(
		API_ENDPOINTS.convertPosition,
		payload,
		{},
		'',
	);
	const result = handleOdinApi(response);
	return result;
};

export const fetch_realised_pnl = async (payload = {}, Api) => {
	const response = await Api.get(API_ENDPOINTS.getPnlStatement, payload);
	const result = handleApi(response);
	return result;
};

// EDIS
export const fetch_edis_summary = async (Api) => {
	const response = await Api.get(API_ENDPOINTS.getEdiSummary);
	const result = handleApi(response);
	return result;
};

export const fetch_dp_details = async (Api) => {
	const response = await Api.get(API_ENDPOINTS.edisDpDetails);
	const result = handleApi(response);
	return result;
};

export const fetch_edis_url = async (payload = {}, Api) => {
	const EDIS_URL = API_ENDPOINTS.edisRedirect;
	const response = await Api.post(EDIS_URL, payload);
	const result = handleApi(response);
	return result;
};

export const generate_new_tpin = async (Api) => {
	const response = await Api.get(API_ENDPOINTS.generateNewTpin);
	const result = handleApi(response);
	return result;
};

export const fetch_holdings_v1 = async (Api) => {
	const response = await Api.get(API_ENDPOINTS.FETCH_HOLDINGS_V1);
	const result = handleApi(response);
	return result;
};
